module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-14-5b17f353400a1d94003502dbce8646a1.jpg";